import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { errorToast, successToast, warnToast } from "../../helpers/toast";
import { isNumber } from "../../utils/validation";

import {
  useEditLocationMutation,
  useLazyGetByIdLocationQuery,
  usePostAddLocationMutation,
} from "../../services/location";

const AddLocation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ByIdDetails, setByIdDetails] = useState<any>(null);
  const [addBoost, { isLoading }] = usePostAddLocationMutation();
  const [updateBoost] = useEditLocationMutation();
  const [fetchById] = useLazyGetByIdLocationQuery();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      lat: "",
      lng: "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      lat: Yup.string().required("This field is required"),
      lng: Yup.string().required("This field is required"),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);

      const body = {
        name: values.title,
        latitude: Number(values.lat),
        longitude: Number(values.lng),
      };
      console.log(body, "body");

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      try {
        if (!id) {
          const response = await addBoost(encryptedBody).unwrap();
          if (response?.statusCode === 200) {
            successToast("Location Added Successfully.");
            navigate("/manage-location");
          }
        } else {
          const response = await updateBoost({
            id: id,
            body: encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            successToast("Location Updated Successfully.");
            navigate("/manage-location");
          }
        }
      } catch (error: any) {
        errorToast(error?.data?.message);
      } finally {
        formik.setSubmitting(false);
      }
    },
  });
  const fetchDataById = async (id: any) => {
    try {
      const response = await fetchById({ userId: id }).unwrap();
      if (response.statusCode === 200) {
        setByIdDetails(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDataById(id);
    }
  }, [id]);

  useEffect(() => {
    if (ByIdDetails) {
      formik.setValues({
        title: ByIdDetails?.name || "",
        lat: ByIdDetails?.latitude || "",
        lng: ByIdDetails?.longitude || "",
      });
    }
  }, [ByIdDetails]);

  return (
    <>
      <div>
        <div className="main_loyout">
          <div className="dashboard">
            <h1>{id ? `Edit Location` : `Add Location`}</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-location");
              }}
            >
              Back
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Typography className="custom_label">Name</Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="title"
                      // inputProps={{ maxLength: 40 }}
                      variant="outlined"
                      fullWidth
                      value={formik.values.title}
                      placeholder="Enter Name"
                      className="text_field"
                      onBlur={formik.handleBlur}
                      onChange={(val) => {
                        if (val.target.value === " ") {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={formik.touched.title && formik.errors.title}
                    ></TextField>
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Typography className="custom_label">Latitude</Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      className="text_field"
                      name="lat"
                      variant="outlined"
                      fullWidth
                      placeholder="Enter latitude"
                      value={formik.values.lat}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isNumber(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={formik.touched.lat && Boolean(formik.errors.lat)}
                      helperText={formik.touched.lat && formik.errors.lat}
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Typography className="custom_label">Longitude</Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      className="text_field"
                      name="lng"
                      variant="outlined"
                      fullWidth
                      placeholder="Enter longitude"
                      value={formik.values.lng}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isNumber(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={formik.touched.lng && Boolean(formik.errors.lng)}
                      helperText={formik.touched.lng && formik.errors.lng}
                    />
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    Save
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AddLocation;
